import LeftGridTemplate from "./LeftGridTemplate"; // Importing the LeftGridTemplate component
import FormPageTemplateStyles from "./FormPageTemplateStyles"; // Importing custom styles for the form page
import { Grid } from "@mui/material"; // Importing Grid component from Material-UI

// FormPageTemplate component definition
const FormPageTemplate = ({
  rightGridForm, // JSX for the right grid form content
  leftGridTitle, // Title for the left grid section
  leftGridSubtitle, // Subtitle for the left grid section
  backUrl, // URL to navigate back to...If page does not support back navigation , just do not include backUrl in props
  textDown,
  textColor,
  leftGridBG,
}) => {
  return (
    <FormPageTemplateStyles  className="formPageTemplate" textDown={textDown} textColor={textColor} leftGridBG={leftGridBG}>
      <Grid container className="gridContainer">
        <Grid item xs={12} sm={6} md={4} className="leftGridWrapper">
          {/* Left grid section */}
          <LeftGridTemplate
            title={leftGridTitle} // Passing title to LeftGridTemplate component
            subtitle={leftGridSubtitle} // Passing subtitle to LeftGridTemplate component
            backUrl={backUrl} // Passing backUrl to LeftGridTemplate component
          />
        </Grid>

        <Grid item xs={12} sm={6} md={8} className="rightGridWrapper">
          {/* Right grid section */}
          {/* Rendering the form content passed as a prop */}
          {rightGridForm}
        </Grid>
      </Grid>
    </FormPageTemplateStyles>
  );
};

export default FormPageTemplate; // Exporting the FormPageTemplate component
